module.exports = __webpack_public_path__ + "static/img/home_spec_col_1.c3d6ae5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_spec_col_1.jpg
// module id = eXfM
// module chunks = 0